<figure class="mb-0">
  @if (isMaxWidth$ | async) {
  <atx-media
    [media]="media"
    [videoPlayerProps]="videoPlayerProps"
    [objectFit]="'cover'"
    class="backstretch"
  ></atx-media>
  }
  <atx-media
    [media]="media"
    [videoPlayerProps]="videoPlayerProps"
    [objectFit]="'cover'"
  ></atx-media>
  <figcaption class="text-center">
    @if (title) {
    <h2 class="text-light h1">{{ title }}</h2>
    } @if (subtitle) {
    <p class="text-light h3">{{ subtitle }}</p>
    }
  </figcaption>
  <a
    [routerLink]="disabledRouterLink ? null : linkInfo.url"
    [queryParams]="linkInfo.params"
    (click)="linkClick.emit()"
  >
  </a>
</figure>
